import type { OperationStatus } from 'types/operations';

export enum Direction {
	INWARD = 'inward',
	OUTWARD = 'outward',
}

export interface Transaction {
	id: string;
	account_uuid: string;
	batch_id: string | undefined;
	status: OperationStatus;
	payment_type: string;
	amount: number;
	currency: string;
	accountId: string;
	account: string;
	execution_date: string;
	processing_started_at: string;
	settled_at: string;
	payment_urgency: string;
	payment_details: string;
	document_number: string;
	beneficiary: Beneficiary;
	ultimate_beneficiary: UltimateBeneficiary;
	primary_payer: Payer;
	payer: Payer;
	created_at: string;
	correspondent?: {
		address: Address;
		bic: string;
		name: string;
	};
	direction: Direction;
}

interface Id {
	type?: string;
	value?: string;
}

export interface Payer {
	id: Id;
	name: string;
	iban: string;
}

export interface Beneficiary {
	name: string;
	address: Address;
	account_number?: string;
	id: Id;
	bank?: {
		address: Address;
		bic: string;
		name: string;
	};
}

export interface UltimateBeneficiary {
	name: string;
	account_number: string;
	address: Address;
	id: Id;
}

export interface Address {
	country: string;
	postal_code?: string;
	town: string;
	building_number?: string;
	building_name?: string;
	country_sub_division?: string;
	street_name?: string;
	// ToDo: remove when BT-996-structured-addresses-in-ib-payments will be removed
	line?: string;
}

export enum OPERATION_STATUS {
	FAILED = 'failed',
	UNSIGNED = 'unsigned',
	CREATED = 'created',
}
